"use client";

import { useEffect, useState } from "react";
import { useLocale } from "next-intl";
import type { UpcomingAppointment } from "./MobileMyAppointments";

type State = { loading: boolean; session: boolean; appointments: UpcomingAppointment[] };

/** Fetch client-side des RDV à venir du patient — jamais server-rendu sur la homepage (page publique cachée CDN). */
export function useUpcomingAppointments(): State {
  const locale = useLocale();
  const [state, setState] = useState<State>({ loading: true, session: false, appointments: [] });

  useEffect(() => {
    let cancelled = false;
    fetch(`/api/mon-compte/upcoming-appointments?locale=${locale}`, { credentials: "include", cache: "no-store" })
      .then((r) => (r.ok ? r.json() : { session: false, appointments: [] }))
      .then((d: { session: boolean; appointments: UpcomingAppointment[] }) => {
        if (!cancelled) setState({ loading: false, session: !!d.session, appointments: d.appointments ?? [] });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, session: false, appointments: [] });
      });
    return () => {
      cancelled = true;
    };
  }, [locale]);

  return state;
}
